import React from 'react';
import { ArrowRight } from 'lucide-react';

const options = [
  {
    num: '01',
    type: 'ENTERPRISE PLATFORM',
    title: 'Deploy the Engine.',
    desc: 'Turnkey cloud or sovereign in-tenant enclave. Arm your deal teams and investment committees with permanent cognitive horsepower.',
    cta: 'Connect with Platform Partner',
    inquiryType: 'Platform',
    footnote: 'Annual firm license · Live in 24 hours or private VPC',
    dark: true,
    dotColor: 'bg-[#F58220]',
  },
  {
    num: '02',
    type: 'TRANSACTION SPRINT',
    title: 'Deliver the Mandate.',
    desc: 'Engage our foundry on an active live deal. 3-day turnarounds for strategic diligence, AI moat audits, or sector mapping.',
    cta: 'Connect with Deal Partner',
    inquiryType: 'Deal',
    footnote: 'Fixed fee per transaction · Zero software commitment',
    dark: false,
    dotColor: 'bg-slate-400',
  },
];

export const EngageSection = ({ onOpenBriefing }) => {
  return (
    <section id="engage" className="scroll-mt-16 bg-white py-24 px-6 md:px-10 border-t border-slate-100">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-6">
          <span className="text-xs font-mono uppercase tracking-widest text-[#F58220] font-semibold block mb-3">COMMERCIAL ENGAGEMENT</span>
          <h2 className="text-3xl sm:text-5xl font-extrabold text-[#0F172A] tracking-tight mb-4">
            Deploy the platform. Or deliver the mandate.
          </h2>
        </div>
        <p className="text-base text-slate-500 text-center max-w-2xl mx-auto mb-16 leading-relaxed">
          Deploy permanent deal horsepower across your firm&mdash;or engage our foundry on an active live transaction.
        </p>

        {/* Two cards */}
        <div className="grid md:grid-cols-2 gap-6">
          {options.map((option) => (
            <div
              key={option.num}
              className={`rounded-3xl p-8 sm:p-10 flex flex-col ${
                option.dark
                  ? 'bg-[#090E1A] text-white shadow-xl'
                  : 'bg-[#FBFBFB] border border-slate-200 text-[#0F172A] shadow-sm'
              } transition`}
            >
              {/* Header label */}
              <div className="flex items-center gap-2 mb-5">
                <div className={`w-2 h-2 rounded-full ${option.dotColor}`} />
                <span className={`text-[10px] font-bold uppercase tracking-wider font-mono ${
                  option.dark ? 'text-slate-400' : 'text-slate-500'
                }`}>
                  Option {option.num} // {option.type}
                </span>
              </div>

              <h3 className="text-2xl sm:text-3xl font-bold mb-4 tracking-tight">{option.title}</h3>
              <p className={`text-sm sm:text-[15px] leading-relaxed mb-10 ${
                option.dark ? 'text-slate-400' : 'text-slate-600'
              }`}>
                {option.desc}
              </p>

              {/* CTA button + footnote */}
              <div className="mt-auto">
                <button
                  onClick={() => onOpenBriefing && onOpenBriefing(option.inquiryType)}
                  className={`inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-xs font-bold transition-all hover:scale-[1.02] shadow-sm ${
                    option.dark
                      ? 'bg-white text-[#090E1A] hover:bg-slate-100'
                      : 'bg-[#090E1A] text-white hover:bg-slate-800'
                  }`}
                >
                  <span>{option.cta}</span>
                  <ArrowRight size={16} />
                </button>
                <div className={`mt-5 text-[10px] font-mono ${
                  option.dark ? 'text-slate-400' : 'text-slate-500'
                }`}>
                  {option.footnote}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
